import { slugify } from "~/lib/toc";

function nodeToText(children: React.ReactNode): string {
  if (typeof children === "string") return children;
  if (typeof children === "number") return String(children);
  if (Array.isArray(children)) return children.map(nodeToText).join("");
  if (children !== null && typeof children === "object" && "props" in children) {
    return nodeToText((children as React.ReactElement).props.children);
  }
  return "";
}

type HeadingProps = {
  children?: React.ReactNode;
};

export function MdxH2({ children }: HeadingProps) {
  const id = slugify(nodeToText(children));
  return <h2 id={id}>{children}</h2>;
}

export function MdxH3({ children }: HeadingProps) {
  const id = slugify(nodeToText(children));
  return <h3 id={id}>{children}</h3>;
}
